import React      from 'react';
import PropTypes  from 'prop-types';
import './MetricTile.scss';

export default function MetricTile({
  value, label, color, icon, onClick,
}) {
  return (
    <div
      className="metric-tile"
      style={{ '--c': color }}
      onClick={onClick}
    >
      <div className="value">{value}</div>
      <div className="label">{label}</div>

      {/*  ▲ regular content ↓ decorative icon  */}
      <span className="icon">
        {icon /* <img … /> is passed in by HomePage */}
      </span>
    </div>
  );
}

MetricTile.propTypes = {
  value : PropTypes.string.isRequired,
  label : PropTypes.string.isRequired,
  color : PropTypes.string.isRequired,
  icon  : PropTypes.node.isRequired,   // image **is** required
  onClick: PropTypes.func,
};
